import React, { useState } from "react";
import ModalVideo from "react-modal-video";
import CountUp from "react-countup";
import "react-modal-video/css/modal-video.css";
import { Link } from "react-router-dom";
import Technlogiesicon from "./technlogiesicon";
// import ServiceItem from "../service/ServiceItem"
import ServiceItem from "../../service/ServiceItem"
import SliderTwo from "./SliderTwo";
// import HomeTowTeamArea from "../home2/HomeTowTeamArea";
import SliderPicture from "./SliderPicture";
function ServiceDetailsWrap() {
  const [isOpen, setOpen] = useState(false);
  return (
    <>
      <div className="service-section2 pt-120 ">
        <div className="container">
          <div className="row d-flex justify-content-lg-start justify-content-center gy-5">
            <div className="col-lg-5 col-md-5">
              <div
                className="section-card service-details-card wow animate fadeInDown"
                data-wow-duration="1.5s"
                data-wow-delay="0.5s"
              >
                <h2 className="cusm-front">Mobile App Development </h2>
                <p className="cusm-front cusm-lineheight text_jus">
                  At Genius Fixers, we are a leading mobile application development company that provides exceptional services for creating purpose-built mobile apps. We are dedicated to developing top-quality applications with an emphasis on user experience, engagement, and ease of use. Our unparalleled mobile app development services offer our clients the peace of mind and the security of knowing their projects are in capable hands.
                </p>
                <Link
                  to={"#"}
                  class="eg-btn hover-btn sectoin-card-btn hover-btn-cusm"
                >
                  <span style={{ color: "white" }}>
                    Download Profile{" "}
                    <img
                      src={
                        process.env.PUBLIC_URL + "/images/icon/arrow-servc.svg"
                      }

                      alt="images"
                    />
                  </span>
                </Link>
              </div>

            </div>
            <div className="col-lg-7 col-md-7">
              <div className="section-title text-center "></div>
              <div className="service-details-area">
                <div className="service-details-img">
                  <img
                    src={process.env.PUBLIC_URL + "/images/bg/mobile-app-development.png"}
                    // src="https://geniusfixers-usa.web.app/images/bg/MicrosoftTeams-image%20(1).png"
                    alt="images"
                  />
                </div>

                {/* <div className="work-process">
                  <h3>Work Process</h3>
                  <div className="row g-3">
                    <div className="col-lg-3 col-md-6 col-sm-3 col-6">
                      <div className="work-pro-item">
                        <img
                          src={
                            process.env.PUBLIC_URL + "/images/icon/workp1.svg"
                          }
                          alt="images"
                        />
                        <h4>
                          <Link to={"#"}>Research</Link>
                        </h4>
                      </div>
                    </div>
                    <div className="col-lg-3 col-md-6 col-sm-3 col-6">
                      <div className="work-pro-item">
                        <img
                          src={
                            process.env.PUBLIC_URL + "/images/icon/workp2.svg"
                          }
                          alt="images"
                        />
                        <h4>
                          <Link to={"#"}>Idea</Link>
                        </h4>
                      </div>
                    </div>
                    <div className="col-lg-3 col-md-6 col-sm-3 col-6">
                      <div className="work-pro-item">
                        <img
                          src={
                            process.env.PUBLIC_URL + "/images/icon/workp3.svg"
                          }
                          alt="images"
                        />
                        <h4>
                          <Link to={"#"}>Develop</Link>
                        </h4>
                      </div>
                    </div>
                    <div className="col-lg-3 col-md-6 col-sm-3 col-6">
                      <div className="work-pro-item">
                        <img
                          src={
                            process.env.PUBLIC_URL + "/images/icon/workp4.svg"
                          }
                          alt="images"
                        />
                        <h4>
                          <Link to={"#"}>Launch</Link>
                        </h4>
                      </div>
                    </div>
                  </div>
                </div> */}
              </div>
            </div>

            {/* deltail */}
            <div className="col-lg-12 col-md-12">
              <div className="section-title text-center "></div>
              <div className="service-details-area">
                <div className="service-details-content bg-white">
                  {/* section one ----------------------------------------------------------------------------------------- */}
                  <h2

                    style={{ color: "#cf2534" }}
                    className="cusm-front text_jus pt-4 "

                  >
                    Finding the Right Mobile App Development Company for Your Project
                  </h2>
                  <p className="color-black cusm-front cusm-lineheight mb-4 text_jus">
                    At Genius Fixers, our mobile app development services cover a wide range of platforms, technologies and industries. We create hybrid-native, cross-platform and PWA apps to meet your user experience and computing needs. Whether you need an iOS or Android app, our custom designed mobile apps are a unique blend of design, creativity and business capabilities. Our team can help you identify the right platform to use for your project, along with the technological stack needed for success. Plus we'll also provide support for scaling strategies so that your app is ready for future growth. With us on board, users will easily accept and utilize the new app without any discomfort or trouble.
                  </p>
                  <h2

                    style={{ color: "#cf2534" }}
                    className="cusm-front pt-4 "

                  >
                    Benchmarks drive our Mobile App Development services for performance and ROI.
                  </h2>
                  <p className="color-black cusm-front cusm-lineheight mb-4 text_jus">
                    Our Mobile App Development services follow strict Benchmarks for performance and ROI. We are devoted to providing a comprehensive set of services from creating strategies and customizing the app to meet specific requirements, designing user-centric applications, and maintaining them. Our rigorous testing process ensures that all its features function optimally within the app in order to provide the best user experience possible. Firm security protocols guarantee additional protection for users' data. Moreover, we have established non-functional requirements to measure speed, load time, security design, and user experience; making sure users are fully satisfied with our work.Android App Development
                  </p>

                  {/* tools */}
                  {/* <div className=" work-process mt-5">

                    <div className="row g-3">
                      <div className="col-lg-3 col-md-4 col-sm-3 col-6">
                        <div className="work-pro-item">
                          <img
                            src={
                              process.env.PUBLIC_URL + "/images/icon/MicrosoftTeams-image (5).png"
                            }
                            alt="images"
                          />
                          <h5 className="color-black cusm-front">
                            Android App Development
                          </h5>
                        </div>
                      </div>

                      <div className="col-lg-3 col-md-4 col-sm-3 col-6">
                        <div className="work-pro-item">
                          <img
                            src={
                              process.env.PUBLIC_URL + "/images/icon/MicrosoftTeams-image (7).png"
                            }
                            alt="images"
                          />
                          <h5 className="color-black cusm-front">
                            iOS App Development
                          </h5>
                        </div>
                      </div>
                      <div className="col-lg-3 col-md-4 col-sm-3 col-6">
                        <div className="work-pro-item">
                          <img
                            src={
                              process.env.PUBLIC_URL + "/images/icon/MicrosoftTeams-image (8).png"
                            }
                            alt="images"
                          />
                          <h5 className="color-black cusm-front">
                            Enterprise App Development
                          </h5>
                        </div>
                      </div>
                      <div className="col-lg-3 col-md-4 col-sm-3 col-6">
                        <div className="work-pro-item">
                          <img
                            src={
                              process.env.PUBLIC_URL + "/images/icon/workp3.svg"
                            }
                            alt="images"
                          />
                          <h5 className="color-black cusm-front">
                            Hybrid App Development
                          </h5>
                        </div>
                      </div>



                    </div>
                  </div> */}



                  {/* Section two ------------------------------------------------------------------------------------------ */}
                  {/* sass */}
                  <div className="row g-3 service-intro-row mt-5">
                    <h2 style={{ color: "#cf2534" }} className="cusm-front pt-4 ">
                      What Kind of Apps Can Genius Fixers Make?
                    </h2>

                    <div className="col-md-7 col-sm-6">

                      <h3
                        style={{ color: "#cf2534" }}
                        className=" cusm-front  text-just"
                      >
                        On-demand Food Delivery App Development
                      </h3>



                      <p className="para mt-md-2 color-black cusm-front text_jus cusm-lineheight">
                        We support building food delivery mobile apps Like Uber and Postmates. Our Tech experts use state-of-the-art technologies to deliver you a restaurant app that is user-friendly.
                      </p>
                      <p className="para color-black cusm-front mt-md-3">* - Social Media Login</p>
                      <p className="para color-black cusm-front mt-md-3">* - Nearby Restaurants</p>
                      <p className="para color-black cusm-front mt-md-3">* - Restaurant Menu</p>
                      <p className="para color-black cusm-front mt-md-3">* - InApp Payments</p>
                      <p className="para color-black cusm-front mt-md-3">* - Order Tracking</p>
                      <p className="para color-black cusm-front mt-md-3">* - Ratings and Reviews</p>

                    </div>
                    <div className="col-md-5 col-sm-5">
                      <img
                        src={
                          process.env.PUBLIC_URL + " /images/bg/_0034_digital-banking-services.png"
                        }
                        alt="images"
                      />
                    </div>

                  </div>

                  {/* FRONTNED  */}
                  <div className="row g-3 service-intro-row mt-5">
                  <div className="col-md-5 col-sm-5">
                      <img
                        src={
                          process.env.PUBLIC_URL + " /images/bg/graphic_0004_taxi-booking.png"
                        }
                        alt="images"
                      />
                    </div>
                    <div className="col-md-7 col-sm-6 ">
                      <h3
                        style={{ color: "#cf2534" }}
                        className=" cusm-front  text-just"
                      >
                        On-demand Taxi Booking App Development
                      </h3>


                      <p className="para mt-md-2 color-black cusm-front text_jus cusm-lineheight">
                        We guide you to build an Uber-like app, including passenger, driver dashboard, with the admin panel that can leverage your on-demand taxi booking businesses.


                      </p>
                      <p className="para color-black cusm-front mt-md-3">* - Easy Login Processes</p>
                      <p className="para color-black cusm-front mt-md-3">* - Push Notification</p>
                      <p className="para color-black cusm-front mt-md-3">* - Live Tracker</p>
                      <p className="para color-black cusm-front mt-md-3">* - Seamless Payments</p>
                      <p className="para color-black cusm-front mt-md-3">* - Live Chat Option</p>
                      <p className="para color-black cusm-front mt-md-3">* - Ratings and Reviews</p>



                    </div>


                  </div>


                  <div className="row g-3 service-intro-row mt-5">
                    <div className="col-md-7 col-sm-6 ">
                      <h3
                        style={{ color: "#cf2534" }}
                        className=" cusm-front  text-just"
                      >
                        On-demand telemedicine App Development
                      </h3>


                      <p className="para mt-md-2 color-black cusm-front text_jus cusm-lineheight">
                        We guide you to build an Uber-like app, including passenger, driver dashboard, with the admin panel that can leverage your on-demand taxi booking businesses.


                      </p>
                      <p className="para color-black cusm-front mt-md-3">* - Easy Login Processes</p>
                      <p className="para color-black cusm-front mt-md-3">* - Push Notification</p>
                      <p className="para color-black cusm-front mt-md-3">* - Live Tracker</p>
                      <p className="para color-black cusm-front mt-md-3">* - Seamless Payments</p>
                      <p className="para color-black cusm-front mt-md-3">* - Live Chat Option</p>
                      <p className="para color-black cusm-front mt-md-3">* - Ratings and Reviews</p>



                    </div>
                    <div className="col-md-5 col-sm-5">
                      <img
                        src={
                          process.env.PUBLIC_URL + " /images/bg/medicine.png"
                        }
                        alt="images"
                      />
                    </div>

                  </div>



                  <div className="row g-3 service-intro-row mt-5">
                    <div className="col-md-7 col-sm-6 ">
                      <h3
                        style={{ color: "#cf2534" }}
                        className=" cusm-front  text-just"
                      >
                        On-Demand Educational App Development

                      </h3>


                      <p className="para mt-md-2 color-black cusm-front text_jus cusm-lineheight">
                        We guide you to build an Uber-like app, including passenger, driver dashboard, with the admin panel that can leverage your on-demand taxi booking businesses.


                      </p>
                      <p className="para color-black cusm-front mt-md-3">* - Easy Login Processes</p>
                      <p className="para color-black cusm-front mt-md-3">* - Push Notification</p>
                      <p className="para color-black cusm-front mt-md-3">* - Live Tracker</p>
                      <p className="para color-black cusm-front mt-md-3">* - Seamless Payments</p>
                      <p className="para color-black cusm-front mt-md-3">* - Live Chat Option</p>
                      <p className="para color-black cusm-front mt-md-3">* - Ratings and Reviews</p>



                    </div>
                    <div className="col-md-5 col-sm-5">
                      <img
                        src={
                          process.env.PUBLIC_URL + " /images/bg/MicrosoftTeams-image (602).png"
                        }
                        alt="images"
                      />
                    </div>

                  </div>



                  <div className="row g-3 service-intro-row mt-5">
                    <div className="col-md-7 col-sm-6 ">
                      <h3
                        style={{ color: "#cf2534" }}
                        className=" cusm-front  text-just"
                      >
                        On-Demand Human Resources App Development

                      </h3>


                      <p className="para mt-md-2 color-black cusm-front text_jus cusm-lineheight">
                        We guide you to build an Uber-like app, including passenger, driver dashboard, with the admin panel that can leverage your on-demand taxi booking businesses.


                      </p>
                      <p className="para color-black cusm-front mt-md-3">* - Easy Login Processes</p>
                      <p className="para color-black cusm-front mt-md-3">* - Push Notification</p>
                      <p className="para color-black cusm-front mt-md-3">* - Live Tracker</p>
                      <p className="para color-black cusm-front mt-md-3">* - Seamless Payments</p>
                      <p className="para color-black cusm-front mt-md-3">* - Live Chat Option</p>
                      <p className="para color-black cusm-front mt-md-3">* - Ratings and Reviews</p>



                    </div>
                    <div className="col-md-5 col-sm-5">
                      <img
                        src={
                          process.env.PUBLIC_URL + " /images/bg/MicrosoftTeams-image (602).png"
                        }
                        alt="images"
                      />
                    </div>

                  </div>

                  <div className="row g-3 service-intro-row mt-5">
                    <div className="col-md-7 col-sm-6 ">
                      <h3
                        style={{ color: "#cf2534" }}
                        className=" cusm-front  text-just"
                      >
                        On-Demand Video Making and Sharing App Development


                      </h3>


                      <p className="para mt-md-2 color-black cusm-front text_jus cusm-lineheight">
                        We guide you to build an Uber-like app, including passenger, driver dashboard, with the admin panel that can leverage your on-demand taxi booking businesses.


                      </p>
                      <p className="para color-black cusm-front mt-md-3">* - Easy Login Processes</p>
                      <p className="para color-black cusm-front mt-md-3">* - Push Notification</p>
                      <p className="para color-black cusm-front mt-md-3">* - Live Tracker</p>
                      <p className="para color-black cusm-front mt-md-3">* - Seamless Payments</p>
                      <p className="para color-black cusm-front mt-md-3">* - Live Chat Option</p>
                      <p className="para color-black cusm-front mt-md-3">* - Ratings and Reviews</p>



                    </div>
                    <div className="col-md-5 col-sm-5">
                      <img
                        src={
                          process.env.PUBLIC_URL + " /images/bg/MicrosoftTeams-image (602).png"
                        }
                        alt="images"
                      />
                    </div>

                  </div>
                  <div className="row g-3 service-intro-row mt-5">
                    <div className="col-md-7 col-sm-6 ">
                      <h3
                        style={{ color: "#cf2534" }}
                        className=" cusm-front  text-just"
                      >
                        On-Demand Chat App Development


                      </h3>


                      <p className="para mt-md-2 color-black cusm-front text_jus cusm-lineheight">
                        We guide you to build an Uber-like app, including passenger, driver dashboard, with the admin panel that can leverage your on-demand taxi booking businesses.


                      </p>
                      <p className="para color-black cusm-front mt-md-3">* - Easy Login Processes</p>
                      <p className="para color-black cusm-front mt-md-3">* - Push Notification</p>
                      <p className="para color-black cusm-front mt-md-3">* - Live Tracker</p>
                      <p className="para color-black cusm-front mt-md-3">* - Seamless Payments</p>
                      <p className="para color-black cusm-front mt-md-3">* - Live Chat Option</p>
                      <p className="para color-black cusm-front mt-md-3">* - Ratings and Reviews</p>



                    </div>
                    <div className="col-md-5 col-sm-5">
                      <img
                        src={
                          process.env.PUBLIC_URL + " /images/bg/MicrosoftTeams-image (602).png"
                        }
                        alt="images"
                      />
                    </div>

                  </div>
                  <h2

                    style={{ color: "#cf2534" }}
                    className="cusm-front text_jus pt-4 "

                  >
                    Genius Fixers Can Help You Build Your Own Customized Mobile App Platform.
                  </h2>
                  <p className="color-black cusm-front cusm-lineheight mb-4 text_jus">
                    At Genius Fixers, we specialize in custom mobile app development from start to finish! Our experienced team will help you design an agile solution that fits your goals and budget without any hiccups. Building a successful mobile application requires careful planning and understanding of user behaviour. We employ the design sprint approach to identify your users' needs and wants and use this as input to design alternatives. After prototyping the concept and conducting tests with feedback, our developers will develop a final version that meets your requirements for excellent user experience. From building the tech stack to managing your project and doing quality checks, Genius Fixers has got you covered!


                  </p>
                  <h2

                    style={{ color: "#cf2534" }}
                    className="cusm-front pt-4 "

                  >
                    Mobile App Development Solutions from Genius Fixers
                  </h2>
                  <p className="color-black cusm-front cusm-lineheight mb-4 text_jus">
                    Genius Fixers offers comprehensive mobile app development solutions to help you achieve your business goals. Our experienced team of developers use the latest technologies, such as Swift, Kotlin, and React Native, to create robust and user-friendly mobile apps that deliver optimal results. We also boast a portfolio of successful projects and highly skilled designers who specialize in UX/UI design. Moreover, our agile methodology lets us work quickly and be flexible, while our strong business acumen allows us to create applications tailored to your specific needs. At Genius Fixers, we care about customer satisfaction and aim to provide you with an innovative mobile app that brings value to your business.
                  </p>

                  <div className="row d-flex justify-content-center g-4">

                    <div
                      className="col-xl-4 col-lg-4 col-md-6 col-sm-8"
                      data-wow-duration="1.5s"
                      data-wow-delay="0.5s"
                    >
                      <div className="service-item light-mode hover-btn d-flex justify-content-between align-items-center">
                        <div className="s-content pt-4 ">
                          <h4 className="cusm-front">
                            <Link
                              to={`${process.env.PUBLIC_URL}/service-details`}
                            // onClick={scrollTop}
                            >
                              {/* {solution?.heading} */}
                              Customizable Android App Development
                            </Link>
                          </h4>
                          <p className="solution_para_home pt-4">
                            Genius Fixers has extensive experience in creating custom Android apps, giving businesses more opportunities for growth. Our process of app development follows the below steps to ensure that our clients' needs are met with excellence:
                          </p>
                        </div>
                        <span />
                      </div>
                    </div>
                    <div
                      className="col-xl-4 col-lg-4 col-md-6 col-sm-8"
                      data-wow-duration="1.5s"
                      data-wow-delay="0.5s"
                    >
                      <div className="service-item light-mode hover-btn d-flex justify-content-between align-items-center">
                        <div className="s-content pt-4 ">
                          <h4 className="cusm-front">
                            <Link
                              to={`${process.env.PUBLIC_URL}/service-details`}
                            // onClick={scrollTop}
                            >
                              {/* {solution?.heading} */}
                              Customizable Android App Development
                            </Link>
                          </h4>
                          <p className="solution_para_home pt-4">
                            At our Android app development firm in Pakistan, we specialize in the custom creation of mobile apps so that companies operating within the mobility sector can benefit from the best solutions. Our team of dedicated developers strives to offer exceptional services and unmatched quality standards whenever it comes to Android app development.
                          </p>
                        </div>
                        <span />
                      </div>
                    </div>


                    <div
                      className="col-xl-4 col-lg-4 col-md-6 col-sm-8"
                      data-wow-duration="1.5s"
                      data-wow-delay="0.5s"
                    >
                      <div className="service-item light-mode hover-btn d-flex justify-content-between align-items-center">
                        <div className="s-content pt-4 ">
                          <h4 className="cusm-front">
                            <Link
                              to={`${process.env.PUBLIC_URL}/service-details`}
                            // onClick={scrollTop}
                            >
                              {/* {solution?.heading} */}
                              Android App Strategy
                            </Link>
                          </h4>
                          <p className="solution_para_home pt-4">
                            When developing an Android app, Genius Fixers takes a strategic approach, focusing on understanding the target audience, defining the app's unique value proposition, selecting the right development approach and tools and technologies, designing an intuitive user interface, adding key features and functions, securing the app with necessary security measures, testing and tweaking to ensure optimal performance, marketing and promotion of the app in order to increase its visibility and reach users more effectively, as well as continuously improving its features.
                          </p>
                        </div>
                        <span />
                      </div>
                    </div>



                  </div>




                  {/* Node J.S Development Service  */}
                  <div className="row g-3 service-intro-row mt-5">
                    <div className="col-md-7 col-sm-6 ">
                      <h3
                        style={{ color: "#cf2534" }}
                        className=" cusm-front  text-just"
                      >
                       How Will We Mobilize Your Enterprise? 
                      </h3>
                     

                      <p className="para mt-md-2 color-black cusm-front text_jus cusm-lineheight">
                      At our app development business, we mobilize enterprises by leveraging extensive knowledge in Android development. Our experience and capabilities mean that your enterprise’s app will include features like geo-fencing, dashboards for admins and users, real-time reporting, complex databases and payment gateways, plus IoT beacons. We have created apps for a variety of industries such as transportation, technology, music, education, retail, marketing and sports. Trust us to bring your enterprise’s mobile vision to life! 

        Industries 
                      </p>


                      <p className="para mt-md-2 color-black cusm-front cusm-lineheight text_jus">
                      <p className="para mt-md-2 color-black cusm-front cusm-lineheight text_jus">
                        With the help of Android app development, Genius Fixers helps all the major industries, like <b>IT/ITES,</b> <b> NBFC</b>, <b>BFSI</b>, <b>retail</b>, <b>telecom</b>, <b>FMCG</b>, <b>FMCD</b>, e-commerce, logistics, and many more.  
                        </p>
                      </p>
                    </div>
                    <div className="col-md-5 col-sm-5">
                      <img
                        src={
                          process.env.PUBLIC_URL +
                          "https://geniusfixers-usa.web.app/images/bg/MicrosoftTeams-image%20(02).png"
                        }
                        alt="images"
                      />
                    </div>

                  </div>

                  {/* ecommer */}
                  <div className="row g-3 service-intro-row mt-5">
                    <div className="col-md-7 col-sm-6 ">
                      <h3
                        style={{ color: "#cf2534" }}
                        className=" cusm-front  text-just"
                      >
                      Why Genius Fixers for Android App Development? 
                      </h3>


                      <p className="para mt-md-2 color-black cusm-front text_jus cusm-lineheight">
                      Why choose Genius Fixers for Android app development? With years of experience making mobile apps and exceptional digital mobility solutions, we are the perfect partner for startups and businesses that want to make a difference in technology. Our capable project managers, Android developers, and designers can complete any mobile development projects quickly. We have worked with over 50 companies so far and 11 of those have successfully achieved valuations of 10 million dollars or more. Our clients have even been featured on popular platforms like ProductHunt, TechCrunch, Cosmopolitan Magazine and Inc.com! By constantly striving to push the needle forward for our clients, we're honored to be one of the top choices for developing successful companies. 

 
                      </p>

                    </div>
                    <div className="col-md-5 col-sm-5">
                      <img
                        src={
                          process.env.PUBLIC_URL +
                          "https://geniusfixers-usa.web.app/images/bg/MicrosoftTeams-image%20(3).png"
                        }
                        alt="images"
                      />
                    </div>

                  </div>

                  {/* sections three */}

                  <ServiceItem />
                  {/* SliderTwo */}

                  <h2

style={{ color: "#cf2534" }}
className="cusm-front text_jus pt-4 "

>
In what timeframe will you be able to develop an application for mobile phones? 
</h2>
<p className="color-black cusm-front cusm-lineheight mb-4 text_jus">
How long will it take to develop an application for mobile phones and the web? Depending on the complexity, user roles, platforms, and functionalities, our design customizations can range between 4-8 weeks. Product development typically takes between 10 to 20 weeks while we continuously release reviews and updates every 2-3 weeks. Additionally, we have the possibility of demonstrating progress to all parties monthly. 

</p>
<h2

style={{ color: "#cf2534" }}
className="cusm-front pt-4 "

>
Who will be my primary contact throughout the entire project? 
</h2>
<p className="color-black cusm-front cusm-lineheight mb-4 text_jus">
Who will be my main point of contact throughout the entire project? We have assigned an experienced and knowledgeable technical project manager who will be responsible for liaising with you. At the start of the project, our CTO, Vice President of Engineering and CEO were also extensively involved. However, when the objectives are finalized and set, your primary contact will become the designated project manager along with a pre-planned channel for escalating further issues. The project manager will provide regular updates to you on all development specifics and is also acting as your key quality assurance analyst. 
</p>

                  <div className="">
                   

                    <SliderTwo />
                  </div>

                  {/* Sections Four */}
                  <div className="row g-3 service-intro-row mt-5">
                    <div className="col-md-7 col-sm-6 mt-5 ">
                      <h3
                        style={{ color: "#cf2534", lineHeight: "45px" }}
                        className=" cusm-front  text-just "
                      >
                       Develop the iOS App your Business Needs Today  
                      </h3>

                      <p className="para mt-md-2 color-black cusm-front text_jus cusm-lineheight">
                      If you are looking for a professional iOS developer to help you create and launch the app your business needs today, look no further than Genius Fixers! Our experienced team of developers have been helping companies across various industries improve their digital presence for over nine years. With strong expertise in both the technical and design aspects of iOS app creation, Genius Fixers is confident that we can provide you with an innovative, stable and scalable solution. We also assist with promotion to ensure your application reach its fullest potential - no matter the scope of your project. As a trusted tech partner, we guarantee success every step of the way. With 50+ apps already launched in various industries and recognition by top brands, Genius Fixers is the right choice for making sure your iOS app meets all expectations. 
                      </p>

                      <div className="row">
                        <div className="col-md-6 col-sm-6">
  

                        <img
                            src={
                              process.env.PUBLIC_URL +
                              "https://geniusfixers-usa.web.app/images/bg/MicrosoftTeams-image%20(03).png"
                            }
                            alt="images"
                          />
                        </div>
                        <div className="col-md-6 col-sm-6">
                          <img
                            src={
                              process.env.PUBLIC_URL +
                              "https://geniusfixers-usa.web.app/images/bg/MicrosoftTeams-image%20(03).png"
                            }
                            alt="images"
                          />
                        </div>
                      </div>


                    </div>
                    <div className="col-md-5 col-sm-5">
                      <img
                        src={
                          process.env.PUBLIC_URL +
                          "https://geniusfixers-usa.web.app/images/bg/MicrosoftTeams-image%20(02).png"
                        }
                        alt="images"
                      />
                    </div>
                  </div>

                  <div className="row g-3 service-intro-row mt-5">
                    <div className="col-md-7 col-sm-6 ">
                      <h3
                        style={{ color: "#cf2534" }}
                        className=" cusm-front  text-just"
                      >
                       iOS App Strategy of Genius Fixers 
                      </h3>

                      <p className="para mt-md-2 color-black cusm-front text_jus cusm-lineheight">
                      At Genius Fixers, our team of experts will provide you with the guidance you need to develop a successful iOS app strategy. We begin by identifying your target audience and conducting market research to determine the unique value proposition of your app. We then focus on defining its core features, developing a monetization strategy, designing a user-friendly interface, and growing your user base through comprehensive marketing efforts. Our ultimate goal is to create an app that meets the needs of your target users and stands out from the competition. Furthermore, we regularly test and iterate on the app to ensure maximum satisfaction for users! 
                      </p>
                      <div className="row">
                        <div className="col-md-6 col-sm-6">
                          <img
                            src={
                              process.env.PUBLIC_URL +
                              "https://geniusfixers-usa.web.app/images/bg/MicrosoftTeams-image%20(03).png"
                            }
                            alt="images"
                          />
                        </div>
                        <div className="col-md-6 col-sm-6">

                        <img
                            src={
                              process.env.PUBLIC_URL +
                              "https://geniusfixers-usa.web.app/images/bg/MicrosoftTeams-image%20(03).png"
                            }
                            alt="images"
                          />
                        </div>
                      </div>


                    </div>
                    <div className="col-md-5 col-sm-5">
                      <img
                        src={
                          process.env.PUBLIC_URL +
                          "https://geniusfixers-usa.web.app/images/bg/MicrosoftTeams-image%20(02).png"
                        }
                        alt="images"
                      />
                    </div>
                  </div>

                  <div className="row g-3 service-intro-row mt-5">
                    <div className="col-md-7 col-sm-6 ">
                      <h3
                        style={{ color: "#cf2534" }}
                        className=" cusm-front  text-just"
                      >
                       Custom iOS App Development: 
                      </h3>

                      <p className="para mt-md-2 color-black cusm-front text_jus cusm-lineheight">
                      Here at Genius Fixers, we understand the importance of custom iOS app development and have crafted a set of best practices tailored to meet the needs of our clients from around the world. From designing with the user in mind, writing optimised code, following Apple's Human Interface Guidelines and using the latest technologies to testing and implementing push notifications, thinking about accessibility and adopting Apple's APIs and frameworks to monitor and update apps regularly and provide maintenance; Our team guarantee results that fulfill all expectations – making sure that everything runs smoothly and perform as expected. All these stages are managed professionally by an experienced team who pay attention to detail at all times. The end result is an app that looks great, fits perfectly within Apple’s ecosystem, provides a superb user experience while also being secure and safe for your users.  
                      </p>
                      <div className="row">
                        {/* <div className="col-md-6 col-sm-6">
                        <img
                          src={
                            process.env.PUBLIC_URL +
                            "https://geniusfixers-usa.web.app/images/bg/MicrosoftTeams-image%20(03).png"
                          }
                          alt="images"
                        />
                      </div> */}
                      </div>





                    </div>
                    <div className="col-md-5 col-sm-5">
                      <img
                        src={
                          process.env.PUBLIC_URL +
                          "https://geniusfixers-usa.web.app/images/bg/MicrosoftTeams-image%20(02).png"
                        }
                        alt="images"
                      />
                    </div>
                  </div>

                  <div className="row g-3 service-intro-row mt-5">
                    <div className="col-md-7 col-sm-6 ">
                      <h3
                        style={{ color: "#cf2534" }}
                        className=" cusm-front  text-just"
                      >
                     Enterprise Mobile App Development 
                      </h3>

                      <p className="para mt-md-2 color-black cusm-front text_jus cusm-lineheight">
                      Enterprise mobile app development is a specialized process where custom applications are created for use internally within a company. These apps enable improved communication, enhanced productivity, and streamlined processes which directly benefit the business. Enterprise mobile apps require specialized security measures such as encryption and multi-factor authentication to protect sensitive data and must integrate with the organization’s existing ERP or CRM systems. In comparison with consumer mobile apps, enterprise mobile app development requires unique approaches that focus on addressing specific business needs. Throughout the development process, developers, analysts and other stakeholders collaborate in order to ensure the application meets the exact requirements of an organization. Ultimately, enterprise mobile app development aims to provide employees access to relevant tools at all times from any location, thus allowing increased productivity and customer satisfaction while staying ahead of competition in today’s highly digital world. 
                      </p>
                      <div className="row">
                        {/* <div className="col-md-6 col-sm-6">
                        <img
                          src={
                            process.env.PUBLIC_URL +
                            "https://geniusfixers-usa.web.app/images/bg/MicrosoftTeams-image%20(03).png"
                          }
                          alt="images"
                        />
                      </div> */}
                      </div>


                    </div>
                    <div className="col-md-5 col-sm-5">
                      <img
                        src={
                          process.env.PUBLIC_URL +
                          "https://geniusfixers-usa.web.app/images/bg/MicrosoftTeams-image%20(02).png"
                        }
                        alt="images"
                      />
                    </div>
                  </div>
                  <div className="row g-3 service-intro-row mt-5">
                    <div className="col-md-7 col-sm-6 ">
                      <h3
                        style={{ color: "#cf2534" }}
                        className=" cusm-front  text-just"
                      >
                    Genius Fixers Enterprise Mobile App Development Strategy 
                      </h3>

                      <p className="para mt-md-2 color-black cusm-front text_jus cusm-lineheight">
                      Developing an enterprise mobile app is an intricate process that requires a well-planned strategy in order to ensure success. At Genius Fixers, we start by identifying the particular business problem you are trying to solve with your app, as well as defining your target audience and conducting market research into what comparable apps exist out there. Afterwards, our team of professionals will consider the technical requirements and build cross-functional teams to carry on the development of the app. We also create a roadmap detailing timelines and milestones for its completion, before implementing robust security measures through encryption and multi-factor authentication. Thorough testing is then conducted before release, and afterwards our experts keep monitoring and updating the app as needed in order to maintain its relevance for your organization. 
                      </p>
                      <div className="row">
                        {/* <div className="col-md-6 col-sm-6">
                        <img
                          src={
                            process.env.PUBLIC_URL +
                            "https://geniusfixers-usa.web.app/images/bg/MicrosoftTeams-image%20(03).png"
                          }
                          alt="images"
                        />
                      </div> */}
                      </div>



                    </div>
                    <div className="col-md-5 col-sm-5">
                      <img
                        src={
                          process.env.PUBLIC_URL +
                          "https://geniusfixers-usa.web.app/images/bg/MicrosoftTeams-image%20(02).png"
                        }
                        alt="images"
                      />
                    </div>
                  </div>
                  <div className="row g-3 service-intro-row mt-5">
                    <div className="col-md-7 col-sm-6 ">
                      <h3
                        style={{ color: "#cf2534" }}
                        className=" cusm-front  text-just"
                      >
            Hybrid App Development 
                      </h3>

                      <p className="para mt-md-2 color-black cusm-front text_jus cusm-lineheight">
                      Hybrid app development by Genius Fixers combines the advantages of native apps and web-based apps into a single application for multiple platforms such as iOS, Android, etc. It leverages web technologies like HTML, CSS, JavaScript to build the app’s user interface and core functions that run inside an native webview. It is often faster to develop and more cost-effective than making individual native apps for each platform. Hybrid app development can also offer access to wider pool of developers skilled with web technologies, facilitate easy updates and maintenance using one codebase. However, it should be noted that hybrid apps may not provide the same performance or native user experience as their native counterparts. Additionally, some devices might not be able to use hardware/software features with hybrid apps due to compatibility issues. Ultimately, hybrid app development is suitable for companies seeking an effective way to reach out to a large audience; yet may not be ideal for those organizations looking for superior performance and advanced user experience from their mobile applications. 

 
                      </p>



                    </div>
                    <div className="col-md-5 col-sm-5">
                      <img
                        src={
                          process.env.PUBLIC_URL +
                          "https://geniusfixers-usa.web.app/images/bg/MicrosoftTeams-image%20(02).png"
                        }
                        alt="images"
                      />
                    </div>
                  </div>
                  <div className="row g-3 service-intro-row mt-5">
                    <div className="col-md-7 col-sm-6 ">
                      <h3
                        style={{ color: "#cf2534" }}
                        className=" cusm-front  text-just"
                      >
                     How does Genius Fixers create Hybrid Apps? 
                      </h3>

                      <p className="para mt-md-2 color-black cusm-front text_jus cusm-lineheight">
                      How does Genius Fixers create Hybrid Apps? To effectively develop hybrid applications, Genius Fixers uses a comprehensive strategy. This includes determining the goals and needs of the app, choosing an efficient framework like Ionic, React Native or Xamarin, and focusing on user experience with attractive yet easy-to-understand interfaces. Along with optimizing for performance via techniques such as lazy loading and image optimization, they also ensure that the app can access native features of a device efficiently and runs without any bugs or delays. Finally, regular testing, monitoring and updates are applied to refine user experience and deliver maximum value to your organisation. 
                      </p>



                    </div>
                    <div className="col-md-5 col-sm-5">
                      <img
                        src={
                          process.env.PUBLIC_URL +
                          "https://geniusfixers-usa.web.app/images/bg/MicrosoftTeams-image%20(02).png"
                        }
                        alt="images"
                      />
                    </div>
                  </div>

                  {/* Section Five */}

                  <h2
                    style={{ color: "#cf2534" }}
                    className="cusm-front text_jus pt-4"
                  >
                   Create an App for Any Device 
                  </h2>
                  <p className="color-black cusm-front cusm-lineheight mb-4 text_jus">
                  Developing an app for any device can be a daunting task, but at our company we make it easy. Our experienced iOS professionals use cutting-edge technology to offer top-notch app development with enhanced features like scalability, durability, security, and innovation. We want your app to reach maximum success in the shortest amount of time, so let us assist you in this important process! 
                  </p>



                  {/* sections Six */}
                  <h2
                    style={{ color: "#cf2534" }}
                    className="cusm-front text_jus pt-4"
                  >
                   iPad App Development by Genius Fixers 
                  </h2>
                  <p className="color-black cusm-front cusm-lineheight mb-4 text_jus">
                  Genius Fixers offers comprehensive iPad app development services, allowing organizations to create custom iPad applications tailored to their needs and their users' requirements. The process starts with ideation and concept design and continues through development, testing, deployment, and ongoing maintenance and updates. Each stage in the process is designed to ensure the end product meets users' expectations and helps the company achieve its business objectives. With Genius Fixers on board, organizations can rest assured their iPad app project will be handled professionally by a team of experienced professionals. 

 
                  </p>

                

                  <h3 className="color-black cusm-front mt-4 ">
                  iWatch app development 
                  </h3>
                  <p className="para cusm-front cusm-lineheight">
                  When developing an iWatch app, it is necessary to have a good understanding of the watchOS platform as well as the needs of its users. To fully take advantage of the unique features of the iWatch, developers should be adept in programming language Swift and working with Apple's Xcode and other development environments. The goal for iWatch app development should ultimately be creating apps that are responsive, intuitive, and engaging; helping fulfil the user’s needs  whether used for personal or business applications. By having a well designed iWatch app, it will give users a positive overall experience while using their device. 

 
                  </p>







                </div>


                <div className="row g-3 service-intro-row mt-5">
                    <div className="col-md-7 col-sm-6 mt-5 ">
                      <h3
                        style={{ color: "#cf2534", lineHeight: "45px" }}
                        className=" cusm-front  text-just "
                      >
                     Apple TV Development 
                      </h3>

                      <p className="para mt-md-2 color-black cusm-front text_jus cusm-lineheight">
                      Apple TV development is all about creating software applications that work with Apple’s tvOS operating system. These apps could be entertainment-focused, enabling users to watch movies and shows, or more complex apps, allowing them to play games, interact with other devices and more. The development process requires an understanding of the needs of tvOS users and the ability to make engaging experiences that take advantage of the features of Apple TV. This may involve working with Swift and Xcode, two commonly used programming languages for Apple TV. The overall aim is to craft user-friendly apps that facilitate personal or business use of the device, elevating its performance and appeal. 
                      </p>

                      <div className="row">
                        <div className="col-md-6 col-sm-6">
  

                        <img
                            src={
                              process.env.PUBLIC_URL +
                              "https://geniusfixers-usa.web.app/images/bg/MicrosoftTeams-image%20(03).png"
                            }
                            alt="images"
                          />
                        </div>
                        <div className="col-md-6 col-sm-6">
                          <img
                            src={
                              process.env.PUBLIC_URL +
                              "https://geniusfixers-usa.web.app/images/bg/MicrosoftTeams-image%20(03).png"
                            }
                            alt="images"
                          />
                        </div>
                      </div>


                    </div>
                    <div className="col-md-5 col-sm-5">
                      <img
                        src={
                          process.env.PUBLIC_URL +
                          "https://geniusfixers-usa.web.app/images/bg/MicrosoftTeams-image%20(02).png"
                        }
                        alt="images"
                      />
                    </div>
                  </div>

                  <div className="row g-3 service-intro-row mt-5">
                    <div className="col-md-7 col-sm-6 mt-5 ">
                      <h3
                        style={{ color: "#cf2534", lineHeight: "45px" }}
                        className=" cusm-front  text-just "
                      >
                  Apple TV Development at Genius Fixers 
                      </h3>

                      <p className="para mt-md-2 color-black cusm-front text_jus cusm-lineheight">
                      At Genius Fixers, our Apple TV development team creates custom Apple TV apps that deliver real value to the user and help reach business objectives. We focus on building an enjoyable user experience through easily navigable graphics, controls, and animations, utilizing the device's special features such as its big screen and motion sensors. Additionally, our team optimizes app performance by working on quick loading times and smooth operations, while also making sure to abide by Apple design guidelines in providing a consistent look throughout the platform. We consider the living room environment when creating these apps with large text and easy-to-use controls that can be seen from far away. Additionally, we incorporate cloud services for better streaming experiences as well as routinely update and improve the app for bug fixes and new features. To finish up, we test our apps thoroughly to make sure they work as intended per Apple requirements. 
                      </p>

                      <div className="row">
                        <div className="col-md-6 col-sm-6">
  

                        <img
                            src={
                              process.env.PUBLIC_URL +
                              "https://geniusfixers-usa.web.app/images/bg/MicrosoftTeams-image%20(03).png"
                            }
                            alt="images"
                          />
                        </div>
                        <div className="col-md-6 col-sm-6">
                          <img
                            src={
                              process.env.PUBLIC_URL +
                              "https://geniusfixers-usa.web.app/images/bg/MicrosoftTeams-image%20(03).png"
                            }
                            alt="images"
                          />
                        </div>
                      </div>


                    </div>
                    <div className="col-md-5 col-sm-5">
                      <img
                        src={
                          process.env.PUBLIC_URL +
                          "https://geniusfixers-usa.web.app/images/bg/MicrosoftTeams-image%20(02).png"
                        }
                        alt="images"
                      />
                    </div>
                  </div>


                  <div className="row g-3 service-intro-row mt-5">
                    <div className="col-md-7 col-sm-6 mt-5 ">
                      <h3
                        style={{ color: "#cf2534", lineHeight: "45px" }}
                        className=" cusm-front  text-just "
                      >
                 What are the benefits that come from using Genius Fixers for iOS App Development? 
                      </h3>

                      <p className="para mt-md-2 color-black cusm-front text_jus cusm-lineheight">
                      The benefits of using Genius Fixers for iOS app development are numerous. For starters, companies can access our expertise and experience, ensuring that their product is of the highest quality by taking advantage of our strict processes and methodologies for quality assurance. We also uphold a user-centered approach to design in order to create enjoyable and intuitive experiences for users. Additionally, working with us can lead to time and cost savings due to our available resources and expertise being more easily accessible than an in-house development team. Furthermore, Genius Fixers has access to advanced technologies which can be used to create new and interesting apps. We also provide regular support and maintenance for all clients as well as scaling capabilities when needed. As a tech partner since 2010, we have been helping companies create innovative software solutions tailored to their specific needs through collaboration with our whole ecosystem of product architects, community members, growth hackers, etc. Choose Genius Fixers as your technology partner today  
                      </p>

                      <div className="row">
                        <div className="col-md-6 col-sm-6">
  

                        <img
                            src={
                              process.env.PUBLIC_URL +
                              "https://geniusfixers-usa.web.app/images/bg/MicrosoftTeams-image%20(03).png"
                            }
                            alt="images"
                          />
                        </div>
                        <div className="col-md-6 col-sm-6">
                          <img
                            src={
                              process.env.PUBLIC_URL +
                              "https://geniusfixers-usa.web.app/images/bg/MicrosoftTeams-image%20(03).png"
                            }
                            alt="images"
                          />
                        </div>
                      </div>


                    </div>
                    <div className="col-md-5 col-sm-5">
                      <img
                        src={
                          process.env.PUBLIC_URL +
                          "https://geniusfixers-usa.web.app/images/bg/MicrosoftTeams-image%20(02).png"
                        }
                        alt="images"
                      />
                    </div>
                  </div>

                {/* section ten */}
                
  
                {/* section 12 */}
 

                <div className="container-fluid mt-4">
                  <div className="row d-flex justify-content-lg-center justify-content-center gy-5 ">

                    <div className="col-lg-12 col-md-8">

                      <div className="service-details-area">

                        <div className="">



                          <div className="service-details-img">
                            <img
                              // src={process.env.PUBLIC_URL + "/images/bg/MicrosoftTeams-image (03).png"}
                              src="https://geniusfixers-usa.web.app/images/bg/MicrosoftTeams-image%20(03).png"
                              alt="images"
                            />
                          </div>






                        </div>

                      </div>
                    </div>
                  </div>
                </div>

                {/* <div className="work-process">
                  <h3>Work Process</h3>
                  <div className="row g-3">
                    <div className="col-lg-3 col-md-6 col-sm-3 col-6">
                      <div className="work-pro-item">
                        <img
                          src={
                            process.env.PUBLIC_URL + "/images/icon/workp1.svg"
                          }
                          alt="images"
                        />
                        <h4>
                          <Link to={"#"}>Research</Link>
                        </h4>
                      </div>
                    </div>
                    <div className="col-lg-3 col-md-6 col-sm-3 col-6">
                      <div className="work-pro-item">
                        <img
                          src={
                            process.env.PUBLIC_URL + "/images/icon/workp2.svg"
                          }
                          alt="images"
                        />
                        <h4>
                          <Link to={"#"}>Idea</Link>
                        </h4>
                      </div>
                    </div>
                    <div className="col-lg-3 col-md-6 col-sm-3 col-6">
                      <div className="work-pro-item">
                        <img
                          src={
                            process.env.PUBLIC_URL + "/images/icon/workp3.svg"
                          }
                          alt="images"
                        />
                        <h4>
                          <Link to={"#"}>Develop</Link>
                        </h4>
                      </div>
                    </div>
                    <div className="col-lg-3 col-md-6 col-sm-3 col-6">
                      <div className="work-pro-item">
                        <img
                          src={
                            process.env.PUBLIC_URL + "/images/icon/workp4.svg"
                          }
                          alt="images"
                        />
                        <h4>
                          <Link to={"#"}>Launch</Link>
                        </h4>
                      </div>
                    </div>
                  </div>
                </div> */}
              </div>
            </div>
          </div>
        </div>
        {/* <div className="achievment-section2">
        <div className="container">
          <div className="row d-flex align-items-center g-4">
            <div className="col-lg-4 col-md-5 col-sm-6">
              <div className="achv-vdo2">
                <img
                  src={process.env.PUBLIC_URL + "/images/bg/ach-vdo2.png"}
                  alt="images"
                />
                <div className="video-play">
                  <div
                    onClick={() => setOpen(true)}
                    className="video-open video-icon"
                  >
                    <i className="bx bx-play" />
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-8 col-md-7 col-sm-6">

              <div className="quote-text ms-auto">
                <h4 className="cusm-front" style={{color:"white"}}>OUR ACHIEVEMENTS </h4>
                <p  className="cusm-front" style={{color:"white"}}>
                At Genius Fixers, we take great pride in our achievements and are constantly striving to improve and innovate in the technology industry. Here are some of our most notable accomplishments: 

 
                </p>
              </div>
            </div>

    




          </div>
          
        </div>
      </div> */}
      </div>
    </>
  );
}

export default ServiceDetailsWrap;
